export const BONE_MARROW_FILE_ROLES = [
  'identification_document',
  'bone_marrow_donation_proof',
  'redome_registration_proof',
] as const;

export const getBoneMarrowFileRoles = (files?: FileList | File[]) =>
  Array.from(files ?? []).slice(0, BONE_MARROW_FILE_ROLES.length).map((_, index) => BONE_MARROW_FILE_ROLES[index]);
